import { request } from "../../../app/api-client/ApiClient";

/**
 * Metodo para obtener las maquinas asocuadas a un admin
 * @param {Integer} idAdmin 
 */
export function getClientes(dispatch, filter, page, size) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/cliente/findBydocumentOrCell?filter=${filter}&page=${page}&size=${size}`,
		method: "GET",
	}, dispatch);
}
export function updateStatusAuth(dispatch, id) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/cliente/changeStatus/${id}`;
	return request({
		url: url,
		method: "PUT",
	}, dispatch);
}

export function crearCliente(dispatch, Request) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/cliente/create`,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}
export function editarCliente(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/cliente/update`;
	return request({
		url: url,
		method: "PUT",
		body: JSON.stringify(Request),
	}, dispatch);
}